import { Modal, Button, ButtonVariant } from '@usealloy/component-library';

interface ValueRangesConfirmationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ValueRangesConfirmationModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: ValueRangesConfirmationModalProps) => (
  <Modal
    isOpen={isOpen}
    header="Are you sure?"
    hasCloseIcon={false}
    size="small"
    secondaryAction={<Button onClick={onCancel}>Cancel</Button>}
    primaryAction={(
      <Button onClick={onConfirm} variant={ButtonVariant.primary}>
        Remove Value Ranges
      </Button>
    )}
  >
    Are you sure you want to remove &quot;Define ranges for values&quot;?
    Unchecking this box will clear out any range value configuration.
  </Modal>
);

